// extracted by mini-css-extract-plugin
module.exports = {"syncingIndicator":"syncing-indicator_syncingIndicator__2aa8Y","inner":"syncing-indicator_inner__3iNSs","title":"syncing-indicator_title__1tYtE"};